import * as PIXI from "pixi.js";
import { RootEventBus, EnumRootEventBus } from "./managers/RootEventBus";
import Layers from "./layers/Layers";
import UIComponent from "./UIComponent";
import Animation from "./animation/Animation";
import TextureManager from "./managers/TextureManager";
import calcCanvasNewSize from "./utils/calcNewCanvasSize";
import LoadingLayer from "./layers/LoadingLayer";
import { INITIAL_HEIGHT, INITIAL_WIDTH, ROOT_ASSETS_LIST } from "./types/Config";


export default class Game extends PIXI.Application {
  static instance: Game;
  LoadingLayer: LoadingLayer;
  RootEventBus = RootEventBus;
  WIDTH = INITIAL_WIDTH;
  HEIGHT = INITIAL_HEIGHT
  Animation = new Animation();
  SCALE = 1;

  constructor(view: HTMLCanvasElement, assetsList: string[], cb: () => void) {
    super();
    if (!Game.instance) {
      Game.instance = this;
    }
    this.calcGameSize();
    view.style = `transform:scale(${this.SCALE})`
    this.init({
      view: view,
      antialias: true,
      backgroundColor: 0xFFFFFF,
      width: this.WIDTH,
      height: this.HEIGHT
    }).then(() => {
      TextureManager.loadLogo().then(() => {
        const startGame = () => {
          new Layers();
          new UIComponent();
          cb();
          this.checkVideoMode();
        }
        this.LoadingLayer = new LoadingLayer(() => startGame());
        const assets = ROOT_ASSETS_LIST.concat(assetsList);
        TextureManager.load(assets, (p: number) => this.LoadingLayer.drawLoadingButton(p)).then(() => {
          console.log("loaded assets");
          this.ticker.add(delta => this.update(delta))
        });
      })
    })
  }
  static getInstance = (): Game => Game.instance;
  getDim = () => ({ WIDTH: this.WIDTH, HEIGHT: this.HEIGHT });
  update = (delta: PIXI.Ticker) => this.Animation.update(delta.lastTime);

  calcGameSize() {
    const dims = calcCanvasNewSize(INITIAL_WIDTH, INITIAL_HEIGHT);
    Object.assign(this, dims);
  }

  checkVideoMode() {
    const params = new URLSearchParams(window.location.search);
    const videoMode = params.get("videomode");
    if (videoMode) {
      RootEventBus.emit(EnumRootEventBus.onVideoMode);
    }
  }
}

